import React from 'react';
import Main from '../components/Main';
import Navbar from '../components/Navbar';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Main />
    </>
  );
};

export default HomePage;
